import styled from "styled-components";

export const AboutMainWrapper = styled.div``;

export const AboutCompanyDetails = styled.div`
  font-size: 1.3rem;
  padding: 0 10px;
  white-space: pre-line;
`;
